import { render } from "./FirmennachzahlerAdd.vue?vue&type=template&id=e45308a2"
import script from "./FirmennachzahlerAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./FirmennachzahlerAdd.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/FirmennachzahlerAdd.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e45308a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e45308a2', __exports__)) {
    api.reload('e45308a2', __exports__)
  }
  
  module.hot.accept("./FirmennachzahlerAdd.vue?vue&type=template&id=e45308a2", () => {
    api.rerender('e45308a2', render)
  })

}


export default __exports__